export default __webpack_public_path__ + "f79701dfbb64bee9745c46cd42175539.png";